import { Box, Grid, Tooltip } from '@material-ui/core';

import {
  CheckBox,
  InformationIcon,
  SingleFieldContactInput,
  TextInput,
  Typography,
  useConfirmationModal,
} from '@room-match/shared-ui-components';
import Stepper from 'components/Stepper/Stepper';
import { ICreateGuardianPayload } from 'shared/interfaces/ITalent';
import { ls } from 'shared/utils/ls';

import { useStyles } from './GuardianContactInformation.styles';
import { countryStateApiService } from 'shared/services/countryStateApiService';
import { getCountryCode } from 'shared/utils/countryStateMapper';
import { COLORS } from 'shared/constants/COLORS';
import { BsAsterisk } from 'react-icons/bs';
import NumberConsent from 'shared/components/NumberConsent/NumberConsent';
const { ERROR_ASTERISK } = COLORS;

interface Props {
  setGuardianInfo: (info: ICreateGuardianPayload) => void;
  guardianInfo: ICreateGuardianPayload;
  smsNotif: boolean;
  setSmsNotif: (value: boolean) => void;
}
const { getCountries } = countryStateApiService();
const GuardianContactInformation: React.FC<Props> = ({ setGuardianInfo, guardianInfo, smsNotif, setSmsNotif }) => {
  const classes = useStyles();
  const { data: countriesData } = getCountries();
  const { getLS } = ls();
  const agency = JSON.parse(getLS('agency') || '{}');

  const handleChange = (event: any) => {
    const {
      target: { value, name, key },
    } = event;

    setGuardianInfo({ ...guardianInfo, [name]: value });
  };

  return (
    <Box component="div" className={classes.root}>
      <Grid item className={classes.header}>
        <Typography fontSize={24}>Guardian Contact Information</Typography>
        <Typography fontSize={13} style={{ marginBottom: 20 }}>
          <span style={{ color: ERROR_ASTERISK }}>*</span>This is the GUARDIAN'S information, You will be
          <br />
          able to enter your child's information on the next step.<span style={{ color: ERROR_ASTERISK }}>*</span>
        </Typography>
        <Stepper steps={4} active={1} />
      </Grid>
      <Grid item className={classes.form}>
        <Grid item style={{ justifyContent: 'unset' }}>
          <TextInput
            label={
              <span>
                First Name <BsAsterisk className="required-asterisk" />
              </span>
            }
            name="first_name"
            placeholder="Guardian's First Name..."
            onChange={handleChange}
          />
        </Grid>
        <Grid item>
          <TextInput
            label={
              <span>
                Last Name <BsAsterisk className="required-asterisk" />
              </span>
            }
            name="last_name"
            placeholder="Guardian's Last Name…"
            onChange={handleChange}
          />
        </Grid>
        <Grid item>
          <TextInput
            disabled
            label={
              <span>
                Guardian's Email <BsAsterisk className="required-asterisk" />
              </span>
            }
            name="Guardian's Email Address..."
            placeholder={guardianInfo.email}
          />
        </Grid>
        <Grid item className={classes.form} style={{ marginBottom: 5 }}>
          <SingleFieldContactInput
            style={{ width: '100%' }}
            country={agency.country ? getCountryCode(countriesData, agency.country).toLowerCase() : 'au'}
            inputValue={guardianInfo.contact_no}
            onChange={(value, data) => {
              setGuardianInfo({ ...guardianInfo, contact_no: value, country_code: data.countryCode });
            }}
            showLabel={true}
            labelTxt={
              <span style={{ fontSize: 18 }}>
                Guardian's Phone Number{' '}
                <BsAsterisk className="required-asterisk" style={{ fontSize: 13, marginLeft: 5 }} />
              </span>
            }
          />
          <NumberConsent aggreed={smsNotif} setAgreed={(value: boolean) => setSmsNotif(value)} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default GuardianContactInformation;
